import React from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';

const CheckboxOption = (props) => {
  const { isSelected, label } = props;
  return (
    <components.Option {...props}>
      <span style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
        <input type="checkbox" checked={isSelected} readOnly style={{ marginTop: '3px' }} />
        <span>{label}</span>
      </span>
    </components.Option>
  );
};

const MENU_MIN_WIDTH = 220;
const MENU_MAX_WIDTH = 360;

const closeMenuOnScroll = (event) => {
  const { target } = event;
  return !(target instanceof Element && target.closest('.multi-filter-select__menu-list'));
};

const MultiFilterSelect = ({ filter, onChange, options, placeholder }) => {
  const selectedValues = (filter && Array.isArray(filter.value)) ? filter.value : [];
  const selectedOptions = options.filter((option) => selectedValues.includes(option.value));
  const hasSelection = selectedOptions.length > 0;

  let summary = placeholder;
  if (selectedOptions.length === 1) {
    summary = selectedOptions[0].label;
  } else if (selectedOptions.length > 1) {
    summary = `${selectedOptions.length} seleccionados`;
  }

  const styles = {
    control: (base) => ({ ...base, minHeight: 38, flexWrap: 'nowrap' }),
    valueContainer: (base) => ({ ...base, flexWrap: 'nowrap', overflow: 'hidden' }),
    placeholder: (base) => ({
      ...base,
      ...(hasSelection ? { color: 'hsl(0, 0%, 20%)' } : {}),
      maxWidth: 'calc(100% - 8px)',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
      width: 'max-content',
      minWidth: Math.max(base.width || 0, MENU_MIN_WIDTH),
      maxWidth: MENU_MAX_WIDTH,
    }),
    option: (base) => ({ ...base, whiteSpace: 'normal' }),
  };

  return (
    <div title={selectedOptions.map((option) => option.label).join(', ')}>
      <Select
        isMulti
        className="filter-select"
        classNamePrefix="multi-filter-select"
        closeMenuOnSelect={false}
        closeMenuOnScroll={closeMenuOnScroll}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
        backspaceRemovesValue={false}
        placeholder={summary}
        noOptionsMessage={() => 'Sin opciones'}
        value={selectedOptions}
        onChange={(selected) => onChange(selected ? selected.map((option) => option.value) : [])}
        options={options}
        components={{ Option: CheckboxOption }}
        menuPosition="fixed"
        menuPortalTarget={document.body}
        styles={styles}
      />
    </div>
  );
};

MultiFilterSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ])),
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    label: PropTypes.string,
  })),
  placeholder: PropTypes.string,
};

MultiFilterSelect.defaultProps = {
  filter: null,
  options: [],
  placeholder: 'Todos',
};

export default MultiFilterSelect;
